module.exports = __webpack_public_path__ + "static/media/next-white.e692a03e.svg";